import styled from 'styled-components';

// ──────────────────────────────────────────────────────────────────────────
// Estilos y helpers compartidos entre las pestañas de "Mis Traslados y
// Promociones" (30/09/2026, a pedido de Jody: la página pasó a mostrarse en
// pestañas, al estilo /adminGestionVacaciones — TabsHeader + un componente por
// pestaña — para que la búsqueda por nombre solo aplique a "Convocatorias
// disponibles" y no a "Entrevistas por completar").
// ──────────────────────────────────────────────────────────────────────────

export const TIPO_LABEL = { T: 'Traslado', P: 'Promoción' };
export const TIPO_ICONO = { T: 'exchange-alt', P: 'chart-line' };

export const formatearFecha = (value) => {
    if (!value) return '-';
    const fecha = new Date(value);
    return isNaN(fecha.getTime()) ? value : fecha.toLocaleDateString('es-PE');
};


export const ContentWrapper = styled.main`
    min-height: 360px;
    margin: 20px 20px 40px;
    padding: 22px 32px 34px;
    background: #f1f3f6;

    @media (max-width: 767px) {
        margin: 15px 10px 30px;
        padding: 20px;
    }
`;

export const SectionTitle = styled.h2`
    margin: 0;
    color: #0b2b57;
    font-family: inherit;
    font-size: 18px;
    font-weight: 700;
`;

export const SectionDescription = styled.p`
    margin: 4px 0 18px;
    color: #7183a0;
    font-size: 12px;
`;

export const CardsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ConvocatoriaCard = styled.article`
    display: flex;
    align-items: center;
    min-height: 66px;
    padding: 14px 18px;
    background: #fff;
    border: 1px solid #e8ebef;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(20, 42, 76, 0.06);

    @media (max-width: 575px) {
        flex-wrap: wrap;
        gap: 10px;
        padding: 14px;
    }
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-right: 16px;
    color: ${({ tipo }) => tipo === 'Promoción' ? '#9b76d8' : '#4e95e8'};
    background: ${({ tipo }) => tipo === 'Promoción' ? '#f1e9ff' : '#e7f0ff'};
    border-radius: 8px;

    @media (max-width: 575px) {
        margin-right: 0;
    }
`;

export const CardInformation = styled.div`
    flex: 1;
    min-width: 0;
`;

export const CardTitle = styled.h3`
    margin: 0 0 5px;
    overflow: hidden;
    color: #102d58;
    font-size: 14px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CardDetails = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ProgressDetails = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    margin-top: 5px;
    color: #6e7e99;
    font-size: 11px;

    strong {
        color: #536985;
        font-weight: 600;
    }
`;

export const TypeBadge = styled.span`
    padding: 2px 7px;
    color: ${({ tipo }) => tipo === 'Promoción' ? '#8159c2' : '#3575c1'};
    background: ${({ tipo }) => tipo === 'Promoción' ? '#f4edff' : '#eaf3ff'};
    border-radius: 3px;
    font-size: 10px;
    font-weight: 600;
`;

export const ClosingDate = styled.span`
    color: #6e7e99;
    font-size: 11px;
`;

export const ApplyButton = styled.button`
    min-width: 98px;
    margin-left: 18px;
    padding: 8px 13px;
    color: #fff;
    background: #1668ad;
    border: 0;
    border-radius: 5px;
    font-size: 11px;
    font-weight: 700;

    &:hover {
        background: #0e568f;
    }

    @media (max-width: 575px) {
        margin-left: auto;
    }
`;

// Misma caja que RegisteredBadge pero en gris: la convocatoria sigue listada
// (CA-01 pide mostrarla igual) y solo se comunica que ya no admite postulaciones.
export const ClosedBadge = styled.span`
    min-width: 98px;
    margin-left: 18px;
    padding: 7px 12px;
    color: #6c757d;
    background: #f0f0f0;
    border-radius: 16px;
    font-size: 11px;
    font-weight: 600;
    text-align: center;

    @media (max-width: 575px) {
        margin-left: auto;
    }
`;

export const RegisteredBadge = styled.span`
    min-width: 98px;
    margin-left: 18px;
    padding: 7px 12px;
    color: #299363;
    background: #e5f8ed;
    border-radius: 16px;
    font-size: 11px;
    font-weight: 600;
    text-align: center;

    svg {
        margin-right: 3px;
    }

    @media (max-width: 575px) {
        margin-left: auto;
    }
`;

export const EmptyState = styled.div`
    padding: 30px 15px;
    color: #71809a;
    font-size: 13px;
    text-align: center;
`;
